import { v4 } from 'uuid'

export function getRequestId() {
  const uuid = v4()
  return uuid
}

export function getShortRequestId() {
  return getRequestId().replace(/-/g, '').substring(0, 32)
}
